import $ from 'jquery';
// Overrides vendor/sylius/sylius/src/Sylius/Bundle/UiBundle/Resources/private/js/sylius-require-confirmation.js
$.fn.extend({
    requireConfirmation() {
        const $this = this;
        $this.each((index, element) => {
            $(element).on('click', event => {
                event.preventDefault();
                const $actionButton = $(event.currentTarget);
                const confirmationText = $actionButton.data('confirmation-text');
                showConfirmationText(confirmationText);
                if ($actionButton.is('a')) {
                    $('#confirmation-button').on('click', event => {
                        event.preventDefault();
                        window.location.href = $actionButton.attr('href') || '';
                    });
                }
                else {
                    $('#confirmation-button').attr('href', 'javascript:void(0)');
                }
                if ($actionButton.is('button')) {
                    const $form = $actionButton.closest('form');
                    const isSubmit = $actionButton.is(':submit');
                    const isFormLoadable = $form.hasClass('loadable');
                    if (isSubmit && isFormLoadable) {
                        $form.removeClass('loading');
                    }
                    $('#confirmation-button').on('click', event => {
                        event.preventDefault();
                        $form.trigger('submit');
                        if (isSubmit && isFormLoadable) {
                            $form.addClass('loading');
                        }
                    });
                }
                $('#confirmation-modal').modal('show');
            });
        });
    },
});
// Overrides vendor/sylius/sylius/src/Sylius/Bundle/UiBundle/Resources/private/js/sylius-bulk-action-require-confirmation.js
$.fn.extend({
    bulkActionRequireConfirmation() {
        const $this = this;
        $this.each((index, element) => {
            $(element).on('click', event => {
                event.preventDefault();
                const $actionButton = $(event.currentTarget);
                const confirmationText = $actionButton.data('confirmation-text');
                showConfirmationText(confirmationText);
                if ($actionButton.is('a')) {
                    $('#confirmation-button').attr('href', $actionButton.attr('href'));
                }
                else {
                    $('#confirmation-button').attr('href', 'javascript:void(0)');
                }
                if ($actionButton.is('button')) {
                    $('#confirmation-button').on('click', event => {
                        event.preventDefault();
                        const form = $actionButton.closest('form');
                        $('input.bulk-select-checkbox:checked').each((index, element) => {
                            $(`<input type="hidden" name="ids[]" value="${$(element).val()}">`).appendTo(form);
                        });
                        form.submit();
                    });
                }
                $('#confirmation-modal').modal('show');
            });
        });
    },
});
const showConfirmationText = (confirmationText) => {
    const $defaultConfirmationModalText = $('.js__default-confirmation-modal-text');
    const $customConfirmationModalText = $('.js__custom-confirmation-modal-text');
    if (confirmationText) {
        $defaultConfirmationModalText.hide();
        $customConfirmationModalText.html(confirmationText);
        $customConfirmationModalText.show();
    }
    else {
        $defaultConfirmationModalText.show();
        $customConfirmationModalText.html('');
        $customConfirmationModalText.hide();
    }
};
